module.exports = __webpack_public_path__ + "9258763daf965ddd948f74c59e8cd571.png";